import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AdminPageShellComponent } from '../../shared/components/admin/admin-page-shell/admin-page-shell.component';
import { AdminStatCardComponent } from '../../shared/components/admin/admin-stat-card/admin-stat-card.component';
import { OfficeDashboardService } from './services/office-dashboard.service';

@Component({
  selector: 'app-office',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    TranslatePipe,
    AdminPageShellComponent,
    AdminStatCardComponent,
  ],
  templateUrl: './office.component.html',
  styleUrl: './office.component.scss',
})
export class OfficeComponent implements OnInit {
  #dashboard = inject(OfficeDashboardService);
  #translate = inject(TranslateService);

  readonly isLoading = this.#dashboard.isLoading;
  readonly publishedCourses = this.#dashboard.publishedCourses;
  readonly pipelineCourses = this.#dashboard.pipelineCourses;
  readonly pendingFactVideos = this.#dashboard.pendingFactVideos;
  readonly enabledFeatureFlags = this.#dashboard.enabledFeatureFlags;
  readonly identityLayerEnabled = this.#dashboard.identityLayerEnabled;
  readonly identityGraceDays = this.#dashboard.identityGraceDays;
  readonly identityKycProvider = this.#dashboard.identityKycProvider;
  readonly patrolDiscordEnabled = this.#dashboard.patrolDiscordEnabled;
  readonly patrolRobloxEnabled = this.#dashboard.patrolRobloxEnabled;
  readonly patrolDiscordGuildCount = this.#dashboard.patrolDiscordGuildCount;
  readonly patrolDiscordBotReady = this.#dashboard.patrolDiscordBotReady;
  readonly patrolRobloxExperienceCount =
    this.#dashboard.patrolRobloxExperienceCount;

  ngOnInit(): void {
    this.#dashboard.prefetch();
  }

  identityLayerLabel(): string {
    return this.identityLayerEnabled()
      ? 'app.admin.dashboard.identityOn'
      : 'app.admin.dashboard.identityOff';
  }

  patrolDiscordLabel(): string {
    if (!this.patrolDiscordEnabled()) {
      return this.#translate.instant('app.admin.dashboard.patrolPlatformOff');
    }
    if (!this.patrolDiscordBotReady()) {
      return this.#translate.instant('app.admin.dashboard.patrolBotOffline');
    }
    return this.#translate.instant('app.admin.dashboard.patrolDiscordReady', {
      count: this.patrolDiscordGuildCount(),
    });
  }

  patrolRobloxLabel(): string {
    if (!this.patrolRobloxEnabled()) {
      return this.#translate.instant('app.admin.dashboard.patrolPlatformOff');
    }
    return this.#translate.instant('app.admin.dashboard.patrolRobloxReady', {
      count: this.patrolRobloxExperienceCount(),
    });
  }
}
